const MAX = 100
const MAXINVENTORY = 100

export { MAX, MAXINVENTORY }
